<script setup lang="ts">
import IconManager, { IconName } from "@/core/IconManager.vue";
import { useI18n } from "vue-i18n";
import { SubEvent } from "@/modules/events/models/sub-event";
import CustomButton from "@/core/components/CustomButton.vue";

defineProps<{
  data: SubEvent;
  editCallBack?: () => void;
  submitButtonTitle?: string;
  submitButtonIcon?: IconName;
}>();

const { t } = useI18n();

function getLocalShortDate(date: Date) {
  return (
    date.getDate() +
    " " +
    date.toLocaleString("pt-PT", { month: "short" }) +
    " " +
    date.getHours() +
    ":" +
    date.getMinutes()
  );
}
</script>

<template>
  <div
    class="flex flex-row items-center bg-background px-5 py-4 shadow-sm rounded-xl gap-4"
  >
    <div class="rounded-full bg-secondary p-2">
      <IconManager name="Calendar" class="text-primary" />
    </div>
    <div class="flex flex-col gap-1">
      <div class="flex flex-row items-center gap-2">
        <span class="font-bold text-sm">{{ data.name }}</span>
      </div>
      <span class="text-light-gray text-xs">
        {{
          getLocalShortDate(data.startDate) +
          " → " +
          getLocalShortDate(data.endDate) +
          " · " +
          data.location +
          " · " +
          (data.resourceTypes?.length ?? 0) +
          " " +
          t("events.detail.subEvents.resourcesAllocated")
        }}
      </span>
    </div>
    <div class="ml-auto">
      <CustomButton
        v-if="editCallBack"
        @click="editCallBack"
        :title="submitButtonTitle ?? t('common.edit')"
        button-styles="bg-light-blue! text-blue!"
      >
        <IconManager :name="submitButtonIcon ?? 'Edit'" />
      </CustomButton>
    </div>
  </div>
</template>
